var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlogLayout',{attrs:{"title":_vm.$t('title.news')}},[_c('BlogNewsArticles',{attrs:{"category":"root"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }